import { ChangeDetectionStrategy, Component, input } from '@angular/core';

@Component({
  selector: 'app-ui-auth-card',
  changeDetection: ChangeDetectionStrategy.OnPush,
  templateUrl: './auth-card.component.html',
  styleUrl: './auth-card.component.scss',
  imports: [],
})
export class UiAuthCardComponent {
  readonly title = input('');
  readonly description = input<string | null>(null);
  readonly logoSrc = input('assets/android-chrome-192x192.png');
  readonly logoAlt = input('Budgets');
  readonly showLogo = input(true);
  readonly size = input<'sm' | 'md'>('sm');
}
